// import { Component } from '@angular/core';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { environment } from '../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { UploadService } from '../../services/upload/upload.service';
import { DmsFile } from '../../modal/upload/model/upload.model';

@Component({
  selector: 'app-award-of-contract',
  standalone: false,
  templateUrl: './award-of-contract.component.html',
  styleUrl: './award-of-contract.component.scss'
})
export class AwardOfContractComponent implements OnInit, AfterViewInit, OnDestroy {
  
    @Input() step: any;
    @Input() id: any;
    @Input() getUrl1: any;
    @Input() postUrl1: any;
    @Output() IRA: EventEmitter<any> = new EventEmitter();
    @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
    @Input() isEditable: boolean = false;
    @Input() stepDetails: any;
    @Input() schemeType: any;
    baseUrl: string = environment.APIUrl;
    isEditorDisabled: boolean = false;
    init: EditorComponent['init'] = init;
    createMode: boolean = true;
    uploadedFileName: string = '';
    file: File;
    uploadedUrl: any;
    apiUrl = environment.APIUrl;
    payload: {
      proposal_id: any;
      proposal_name: any;
    };
    eoiData: any;
    commentForm: FormGroup;
    needGenData: any;
    @ViewChild('fileUpload') fileUpload: FileUpload;
    @ViewChild('editor') editor: EditorComponent;
    private subscriptions = new Subscription();
    @Output() stepCompleted = new EventEmitter<void>();
      @Output() routeConfig: EventEmitter<any> = new EventEmitter();
      @Output() submitProposal: EventEmitter<any> = new EventEmitter();
    userID: any;
    allDmsFiles:any[]=[];
    constructor(
      private messageService: MessageService,
      private fb: FormBuilder,
      private api: ApiService,
      private uploadService: UploadService,
      private route: ActivatedRoute
    ) {
      const role = sessionStorage.getItem('user_role_id');
      this.userID = role;
    }
  
    ngOnInit(): void {
      this.route.queryParams.subscribe((params: any) => {
        const proposalId = params['id'];
        const proposalName = params['name'];
        this.payload = {
          proposal_id: proposalId,
          proposal_name: proposalName,
        };
        this.commentForm = this.fb.group({
          comment: [''],
        });
        this.getProposalData();
        this.getStep1();
      });
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    ngAfterViewInit() {
      setTimeout(() => {
        if (this.isEditable || this.stepDetails?.can_edit) {
          this.isEditorDisabled = false;
          this.commentForm.enable();
        } else {
          this.isEditorDisabled = true;
          this.commentForm.disable();
        }
        this.rebuildEditor();
        
        // Re-patch form values after editor is ready
        if (this.eoiData) {
          console.log('Re-patching form after editor ready:', this.eoiData);
          this.patchFormValues(this.eoiData);
        }
      }, 3000);
    }
    editorReady = false;
    rebuildEditor() {
      this.editorReady = false; // destroy
      setTimeout(() => {
        this.init = this.getTinyInit(); // refresh config
        this.editorReady = true; // recreate editor
        
        // Set content after editor is ready
        setTimeout(() => {
          if (this.eoiData && this.eoiData.comment) {
            console.log('Setting editor content:', this.eoiData.comment);
            this.setEditorContent(this.eoiData.comment);
          }
        }, 100);
      }, 0);
    }
    
    setEditorContent(content: string) {
      // This method will be called to set content in the editor
      if (this.editorReady && content) {
        // Force update the form control
        this.commentForm.patchValue({ comment: content });
        
        // Also try to set content directly in the editor
        if (this.editor && (this.editor as any).editorInstance) {
          (this.editor as any).editorInstance.setContent(content);
          console.log('Editor content set directly to:', content);
        }
        
        console.log('Editor content set to:', content);
      }
    }
    
    getTinyInit(): EditorComponent['init'] {
      return {
        readonly: this.isEditorDisabled,
        setup: (editor: any) => {
          editor.on('init', () => {
            console.log('TinyMCE Editor initialized');
            // Set content when editor is initialized
            if (this.eoiData && this.eoiData.comment) {
              editor.setContent(this.eoiData.comment);
              console.log('Content set in editor init:', this.eoiData.comment);
            }
          });
        }
      };
    }
    getProposalData() {
      let stepID = sessionStorage.getItem('needStepID');
      let url;
      if (this.schemeType == 'rev') {
        url = `/revenue/need-generation/?proposal_step=${stepID}&proposal_step__proposal=${this.payload.proposal_id}`;
      } else if (this.schemeType == 'tdf') {
        url = `/tdf/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`;
      } else {
        url = `/make1/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`;
      }
      const sub = this.api.getAPI(url).subscribe((res: any) => {
        this.needGenData = res[0];
      });
      this.subscriptions.add(sub);
    }
    getStep1() {
      let url;
      let vendor_id = sessionStorage.getItem('final_vendor');
      
      if (this.schemeType == 'tdf') {
        url = `/tdf/section-order/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
      } else if (this.schemeType == 'makeIII') {
        url = `/make1/make2/section-order/?vendor_id=${vendor_id}&proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
      } else if (this.schemeType == 'idex') {
        url = `/idex/section-order/?vendor_id=${vendor_id}&proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
      } else {
        url = `/revenue/section-order/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
      }
      
      const sub = this.api.getAPI(url).subscribe((res: any) => {
        console.log('API Response:', res); // Debug log
        this.eoiData = res;
        const dmsFiles: DmsFile[] = this.eoiData.dms_files;
        this.allDmsFiles = dmsFiles;
        // Handle both array and object responses
        if (Array.isArray(res) && res.length > 0) {
          this.patchFormValues(res[0]);
        } else if (res && typeof res === 'object') {
          this.patchFormValues(res);
        }
      });
      this.subscriptions.add(sub);
    }

      onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res need upload data', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });

  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    })

    // Optionally call delete API
  }

    patchFormValues(data: any): void {
      console.log('Patching form with data:', data); // Debug log
      console.log('Comment value:', data?.comment); // Debug log
      
      const commentValue =  data?.sanction_order?.comment || data?.comment || data?.draft_sotr  || data?.sanction_order?.draft_rfp;
      
      this.commentForm.patchValue({
        comment: commentValue,
      });
  
      this.uploadedUrl = data?.sanction_order?.file || data?.file;
      
      console.log('Form value after patch:', this.commentForm.get('comment')?.value); // Debug log
      
      // If editor is ready, set the content directly
      if (this.editorReady && commentValue) {
        console.log('Setting content in editor from patchFormValues:', commentValue);
        this.setEditorContent(commentValue);
      }
    }
    getFileName(url: string): string {
      const fileName = url.split('/').pop() || 'Unknown File';
      return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
    }
  
    toggleCreateMode(): void {
      this.createMode = !this.createMode;
    }
    clearUpload(fileUpload: any) {
      this.uploadedFileName = null;
      this.uploadedUrl = null;
      fileUpload.clear();
    }
  
    onUpload(event: any): void {
      const file = event.files?.[0];
      this.uploadedFileName = file.name;
      this.file = file;
    }
    onSubmit() {
      const formData = new FormData();
      formData.append('proposal_step', this.step.id);
      formData.append('comment', this.commentForm.get('comment')?.value);
      // formData.append('file', this.file);
      
      let url;
      let vendor_id = sessionStorage.getItem('final_vendor');
      
      if (this.schemeType == 'makeIII') {
        url = `/make1/section-order/`;
        if (this.eoiData?.sanction_order?.id) {
          const sub = this.api
            .putAPI(`${url}${this.eoiData.sanction_order.id}/`, formData)
            .subscribe((res: any) => {
              this.fileUpload.clear();
              this.uploadedFileName = null;
              this.getStep1();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Sanction order updated successfully',
              });
            });
          this.subscriptions.add(sub);
        } else {
          const sub = this.api
            .postAPI(url, formData)
            .subscribe((res: any) => {
              this.fileUpload.clear();
              this.uploadedFileName = null;
              this.getStep1();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Sanction order created successfully',
              });
            });
          this.subscriptions.add(sub);
        }
      } else if (this.schemeType == 'tdf') {
        url = `/tdf/section-order/`;
        if (this.eoiData?.sanction_order?.id) {
          const sub = this.api
            .putAPI(`${url}${this.eoiData.sanction_order.id}/`, formData)
            .subscribe((res: any) => {
              this.fileUpload.clear();
              this.uploadedFileName = null;
              this.getStep1();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Sanction order updated successfully',
              });
            });
          this.subscriptions.add(sub);
        } else {
          const sub = this.api
            .postAPI(url, formData)
            .subscribe((res: any) => {
              this.fileUpload.clear();
              this.uploadedFileName = null;
              this.getStep1();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Sanction order created successfully',
              });
            });
          this.subscriptions.add(sub);
        }
      } else {
        if (this.schemeType == 'idex') {
          url = `/idex/section-order/`;
        } else {
          url = `/revenue/section-order/`;
        }
        
        if (this.eoiData?.sanction_order?.id) {
          const sub = this.api
            .putAPI(`${url}${this.eoiData.sanction_order.id}/`, formData)
            .subscribe((res: any) => {
              this.fileUpload.clear();
              this.uploadedFileName = null;
              this.getStep1();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Sanction order updated successfully',
              });
            });
          this.subscriptions.add(sub);
        } else {
          const sub = this.api
            .postAPI(url, formData)
            .subscribe((res: any) => {
              this.fileUpload.clear();
              this.uploadedFileName = null;
              this.getStep1();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: res.message || 'Sanction order created successfully',
              });
            });
          this.subscriptions.add(sub);
        }
      }
    }
    generatePDF() {
      const payload = {
        url: '/revenue/need/version-control/',
        data: [
          { key: 'Proposal Name', value: this.payload.proposal_name },
          { key: 'Comment', value: this.commentForm.get('comment')?.value },
        ],
      };
      this.generatePDFEmitter.emit(payload);
    }
    goToNextStep() {
      this.stepCompleted.emit();
    }

}
